export default {"src":"/_next/static/image/public/images/ic_facebook.52e099c8a0614eeb42d77332f6df3e49.svg","height":36,"width":36};